import { render, staticRenderFns } from "./DetalhesContratoLicitacaoPropria.vue?vue&type=template&id=6c77421a"
import script from "./DetalhesContratoLicitacaoPropria.vue?vue&type=script&lang=ts"
export * from "./DetalhesContratoLicitacaoPropria.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports